import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { Employee } from '../employee/employee';
import { EboObject } from './ebo-object';

export class EboObjectTO extends EboObject {
  modifiedOn: Dayjs;
  modifiedBy?: Employee;
  modifiedById: string;
  modifiedViaId: string;

  constructor(jsonData?: Partial<EboObjectTO>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.modifiedBy) this.modifiedBy = new Employee(jsonData.modifiedBy);
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
